import { openAiTypes } from "../../ActionTypes/openAiTypes";
import { OpenAiActions, OpenAiState } from "../../types/type";


const initialState: OpenAiState = {
  pending: false,
  body: [],
  error: null,
};

export default (state = initialState, action: OpenAiActions,) => {
  switch (action.type) {
    case openAiTypes.FETCH_OPENAI_REQUEST:
      return {
        ...state,
        pending: false
      };
    case openAiTypes.FETCH_OPENAI_SUCCESS:
      return {
        ...state,
        pending: true,
        body: action.payload.body,
        error: null
      };
    case openAiTypes.FETCH_OPENAI_FAILURE:
      return {
        ...state,
        pending: false,
        body: [],
        error: action.payload.error
      };
    default:
      return {
        ...state
      };
  }
};
